import { render, staticRenderFns } from "./addShop.vue?vue&type=template&id=4cb99b90&scoped=true&"
import script from "./addShop.vue?vue&type=script&lang=js&"
export * from "./addShop.vue?vue&type=script&lang=js&"
import style0 from "./addShop.vue?vue&type=style&index=0&id=4cb99b90&scoped=true&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb99b90",
  null
  
)

export default component.exports